export default __webpack_public_path__ + "static/media/Instagram.76dd5f9e.svg";